export const pt = {
    // Login screen
    modal_login_capital: 'ENTRAR',
    placeholder_email_address: 'introduza o e-mail',
    placeholder_password: 'introduza a senha',
    tooltip_forgot_password: 'Esqueceu a senha?',
    log_in: 'Entrar',

    // Register screen
    modal_signup_capital: 'REGISTAR',
    placeholder_repeat_password: ' repita a senha',
    agree: 'Eu concordo com os ',
    terms: 'Termos',
    modal_register_capital: 'REGISTAR',
    full_name: 'Full name',

    // Price options
    choose_price: 'ESCOLHA O PREÇO',
    subscription_price: 'Subscrição',
    asset_price: 'Ativo',
    paywall_subscription_text: 'Pode cancelar a subscrição a qualquer altura.',
    modal_back: 'ANTERIOR',
    next_button: 'PRÓXIMO',

    // Payments screen
    pay: 'PAGAR',
    pay_with: 'PAGAR COM PAYPAL',
    credit_card: 'cartão de crédito',
    payment_pay: 'Pagar',
    payment_price: 'Preço',
    placeholder_voucher_code: 'código do voucher',
    placeholder_voucher: 'adicionar voucher',
    card_number: 'número do cartão',
    cardholder_name: 'titular do cartão',

    // Forgot password
    forgot_pass_text:
        'Iremos enviar um e-mail com um link para redefinir a sua senha.',
    remember_pass: 'Lembra-se da senha?',
    reset: 'REDEFINIR',

    // Set new password
    modal_enter_your_new_password: 'Introduza a sua nova senha.',
    modal_please_check_your_email:
        'Por favor, verifique o seu e-mail e copie o token para continuar.',
    placeholder_token: 'token',
    new_password: 'nova senha',
    repeat_new_password: 'repita a nova senha',
    cancel: 'cancelar',
    set: 'DEFINIR',

    // Change password
    update: 'atualizar',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'A minha conta',
    member_since: 'Membro desde',
    purchases: 'As minhas compras',
    subscriptions: 'As minhas subscrições',
    account_details: 'Detalhes da conta',
    export_data: 'Exportar os meus dados',
    delete_account: 'Excluir conta',
    email: 'Email',

    // Purchases/Subscriptions
    purchases_link: 'Compras',
    subscriptions_link: 'Subscrições',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Histórico de compras',
    purchased: 'Purchased',
    name: 'name',
    all: 'All',
    active: 'Ativo',
    inactive: 'inactive',
    canceled: 'cancelado',
    type: 'Tipo',
    next_transaction: 'próxima transação',
    cancel_subscription: 'Cancelar subscrição',
    subscriptions_active: 'Subscrições ativas',
    expires_at: 'Expira a',
    no_more_subscriptions: 'Não existem mais subscrições.',
    no_available_subscriptions: 'Não existem subscrições ativas.',
    no_more_active_accesses: 'Não existem mais acessos ativos.',
    no_more_inactive_accesses: 'Não existem mais acessos inativos.',
    no_available_active_accesses: 'Não existem acessos ativos disponíveis.',
    no_available_inactive_accesses:
        ' Não existem acessos inativos disponíveis.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question: 'Tem a certeza que deseja exportar os dados da sua conta?',
    export: 'exportar',
    first_export:
        'A ação de Exportar os Dados da Conta vai exportar todos os dados pessoais da sua conta, incluindo:',
    second_export: 'A sua informação pessoal',
    third_export: 'Histórico dos inícios de sessão',
    fourth_export: 'Lista das suas subscrições',
    fifth_export: 'Lista dos seus pagamentos',
    sixth_export: 'Lista dos seus acessos ao conteúdo premium',
    last_export:
        'Os dados exportados serão enviados para o seu endereço de e-mail como um anexo.',

    // Delete account screen
    delete_question: 'Tem a certeza que deseja excluir a sua conta?',
    delete: 'excluir',
    confirm: "'CONFIRMAR",
    first_delete:
        'A ação de Excluir a Conta vai eliminar todos os seus dados pessoais do sistema, incluindo:',
    second_delete: 'A informação pessoal fornecida no processo de registo',
    third_delete:
        'A localização e informação do dispositivo que recolhemos no processo de autenticação',
    fourth_delete:
        'Todas as informações pessoais armazenadas noutras partes da nossa base de dados',
    fifth_delete:
        'Os únicos dados pessoais que mantemos no sistema correspondem ao registo das transações e subscrições, devido à legislação que temos de respeitar.',
    sixth_delete:
        'Além da eliminação dos dados, a sua conta também será desativada, o que significa que todas as subscrições ativas serão canceladas, todos os acessos atualmente ativos serão revogados e todas as suas sessões ativas, incluindo esta sessão, serão terminadas. Já não poderá autenticar-se e adquirir ativos neste site. A informação da sua conta já não estará disponível em nenhuma lista para a nossa equipa',
    seventh_delete:
        'Este processo pode demorar 1-2 dias após o envio o e-mail de confirmação para o seu endereço eletrónico. O e-mail será apagado do nosso sistema após ser entregue com sucesso.',

    // Inputs validation
    required_field: 'Campo obrigatório',
    email_field: 'por favor introduza um e-mail válido',
    number_field: 'O valor deve ser um número',
    matchPass: 'as senhas não correspondem',
    minpass_field: 'deve ter pelo menos 8 caracteres',
    minname_field: 'deve ter pelo menos 2 caracteres',

    // Footer
    modal_terms: 'Termos',
    modal_privacy: 'Privacidade',
    modal_more: 'MAIS',
    modal_faq: 'FAQ',
    modal_protected: 'O que é isto?',
    logout: 'Sair',
    details: 'Os meus dados',
    preview_protected_by_inplayer: 'Protegido por',
    modal_support: 'Support',

    // Dlc
    dlc_download: 'descarregar',
};



// WEBPACK FOOTER //
// ./src/i18n/portuguese.js